const CheckCircleIconSVG = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="25"
    height="28"
    viewBox="0 0 25 28"
    fill="none"
  >
    <path
      d="M7.7373 14L10.7373 17L16.7373 11M22.2373 14C22.2373 19.5228 17.7602 24 12.2373 24C6.71446 24 2.2373 19.5228 2.2373 14C2.2373 8.47715 6.71446 4 12.2373 4C17.7602 4 22.2373 8.47715 22.2373 14Z"
      stroke="#18C967"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CheckCircleIconSVG;
